export default {
  // 頁面標題
  title: "修改密碼",

  // 表單標籤
  password: "密碼",
  confirmPassword: "確認密碼",

  // 按鈕
  cancel: "取消",
  modifyPassword: "修改密碼",

  // 驗證消息
  pleaseEnterPassword: "請輸入密碼",
  pleaseConfirmPassword: "請再次輸入密碼",
  passwordMismatch: "兩次輸入密碼不一致!",

  // 成功消息
  modifySuccess: "修改成功",
};
